"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var markets = [{
  marketCode: 'ae',
  domain: 'ef.co.ae',
  countryCode: 'ae',
  languageCode: 'ar',
  cultureCode: 'ar-AE',
  secondaryCultureCode: 'en-UE',
  urlLanguageFolder: '',
  languageName: 'Arabic',
  countryName: 'United Arab Emirates',
  countryNameLocale: 'الإمارات العربية المتحدة'
}, {
  marketCode: 'ar',
  domain: 'ef.com.ar',
  countryCode: 'ar',
  languageCode: 'es',
  cultureCode: 'es-AR',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Argentina',
  countryNameLocale: 'Argentina'
}, {
  marketCode: 'at',
  domain: 'ef.at',
  countryCode: 'at',
  languageCode: 'de',
  cultureCode: 'de-AT',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'German',
  countryName: 'Austria',
  countryNameLocale: 'Österreich'
}, {
  marketCode: 'au',
  domain: 'ef-australia.com.au',
  countryCode: 'au',
  languageCode: 'en',
  cultureCode: 'en-AU',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'Australia',
  countryNameLocale: 'Australia'
}, {
  marketCode: 'az',
  domain: 'ef.com/az',
  countryCode: 'az',
  languageCode: 'az',
  cultureCode: 'az',
  secondaryCultureCode: 'ru-AZ',
  urlLanguageFolder: '/az',
  languageName: 'Azerbaijani',
  countryName: 'Azerbaijan',
  countryNameLocale: 'Azərbaycan'
}, {
  marketCode: 'ax',
  domain: 'ef.com/azru',
  countryCode: 'ax',
  languageCode: 'az',
  cultureCode: 'ru-AZ',
  secondaryCultureCode: '',
  urlLanguageFolder: '/azru',
  languageName: 'Russian',
  countryName: 'Azerbaijan',
  countryNameLocale: 'Азербайджан'
}, {
  marketCode: 'be',
  domain: 'ef.be/fr',
  countryCode: 'be',
  languageCode: 'fr',
  cultureCode: 'fr-BE',
  secondaryCultureCode: '',
  urlLanguageFolder: '/fr',
  languageName: 'French',
  countryName: 'Belgium',
  countryNameLocale: 'Belgique'
}, {
  marketCode: 'br',
  domain: 'ef.com.br',
  countryCode: 'br',
  languageCode: 'pt',
  cultureCode: 'pt-BR',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Portuguese',
  countryName: 'Brazil',
  countryNameLocale: 'Brasil'
}, {
  marketCode: 'bx',
  domain: 'ef.be/nl',
  countryCode: 'bx',
  languageCode: 'nl',
  cultureCode: 'nl-BE',
  secondaryCultureCode: '',
  urlLanguageFolder: '/nl',
  languageName: 'Dutch',
  countryName: 'Belgium',
  countryNameLocale: 'België'
}, {
  marketCode: 'ca',
  domain: 'ef.com/ca',
  countryCode: 'ca',
  languageCode: 'ca',
  cultureCode: 'en-CA',
  secondaryCultureCode: '',
  urlLanguageFolder: '/ca',
  languageName: 'English',
  countryName: 'Canada',
  countryNameLocale: 'Canada'
}, {
  marketCode: 'ch',
  domain: 'efswiss.ch/fr',
  countryCode: 'ch',
  languageCode: 'fr',
  cultureCode: 'fr-CH',
  secondaryCultureCode: '',
  urlLanguageFolder: '/fr',
  languageName: 'French',
  countryName: 'Switzerland',
  countryNameLocale: 'Suisse'
}, {
  marketCode: 'cl',
  domain: 'ef.com/cl',
  countryCode: 'cl',
  languageCode: 'cl',
  cultureCode: 'es-CL',
  secondaryCultureCode: '',
  urlLanguageFolder: '/cl',
  languageName: 'Spanish',
  countryName: 'Chile',
  countryNameLocale: 'Chile'
}, {
  marketCode: 'cn',
  domain: 'ef.com.cn',
  countryCode: 'cn',
  languageCode: 'zh',
  cultureCode: 'zh-Hans',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Chinese',
  countryName: 'China',
  countryNameLocale: '中国'
}, {
  marketCode: 'co',
  domain: 'ef.com.co',
  countryCode: 'co',
  languageCode: 'es',
  cultureCode: 'es-CO',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Colombia',
  countryNameLocale: 'Colombia'
}, {
  marketCode: 'cs',
  domain: 'efswiss.ch/de',
  countryCode: 'cs',
  languageCode: 'de',
  cultureCode: 'de-CH',
  secondaryCultureCode: '',
  urlLanguageFolder: '/de',
  languageName: 'German',
  countryName: 'Switzerland',
  countryNameLocale: 'Schweiz'
}, {
  marketCode: 'ct',
  domain: 'efswiss.ch/it',
  countryCode: 'ct',
  languageCode: 'it',
  cultureCode: 'it-CH',
  secondaryCultureCode: '',
  urlLanguageFolder: '/it',
  languageName: 'Italian',
  countryName: 'Switzerland',
  countryNameLocale: 'Svizzera'
}, {
  marketCode: 'cz',
  domain: 'ef-czech.cz',
  countryCode: 'cz',
  languageCode: 'cs',
  cultureCode: 'cs',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Czech',
  countryName: 'Czech Republic',
  countryNameLocale: 'Česká republika'
}, {
  marketCode: 'de',
  domain: 'ef.de',
  countryCode: 'de',
  languageCode: 'de',
  cultureCode: 'de',
  secondaryCultureCode: 'de-DE',
  urlLanguageFolder: '',
  languageName: 'German',
  countryName: 'Germany',
  countryNameLocale: 'Deutschland'
}, {
  marketCode: 'dk',
  domain: 'ef-danmark.dk',
  countryCode: 'dk',
  languageCode: 'da',
  cultureCode: 'da',
  secondaryCultureCode: 'da-DK',
  urlLanguageFolder: '',
  languageName: 'Danish',
  countryName: 'Denmark',
  countryNameLocale: 'Danmark'
}, {
  marketCode: 'dz',
  domain: 'ef.dz/fr',
  countryCode: 'dz',
  languageCode: 'fr',
  cultureCode: 'fr-DZ',
  secondaryCultureCode: '',
  urlLanguageFolder: '/fr',
  languageName: 'French',
  countryName: 'Algeria',
  countryNameLocale: 'Algérie'
}, {
  marketCode: 'dx',
  domain: 'ef.dz/ar',
  countryCode: 'dx',
  languageCode: 'ar',
  cultureCode: 'ar-DZ',
  secondaryCultureCode: '',
  urlLanguageFolder: '/ar',
  languageName: 'Arabic',
  countryName: 'Algeria',
  countryNameLocale: 'الجزائر'
}, {
  marketCode: 'ec',
  domain: 'ef.com.ec',
  countryCode: 'ec',
  languageCode: 'es',
  cultureCode: 'es-EC',
  secondaryCultureCode: 'es-EC',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Ecuador',
  countryNameLocale: 'Ecuador'
}, {
  marketCode: 'es',
  domain: 'ef.com.es',
  countryCode: 'es',
  languageCode: 'es',
  cultureCode: 'es-ES',
  secondaryCultureCode: 'ca-ES',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Spain',
  countryNameLocale: 'España'
}, {
  marketCode: 'fc',
  domain: 'ef.com/cafr',
  countryCode: 'fc',
  languageCode: 'cafr',
  cultureCode: 'fr-CA',
  secondaryCultureCode: '',
  urlLanguageFolder: '/cafr',
  languageName: 'French',
  countryName: 'Canada',
  countryNameLocale: 'Canada'
}, {
  marketCode: 'fi',
  domain: 'ef.fi',
  countryCode: 'fi',
  languageCode: 'fi',
  cultureCode: 'fi',
  secondaryCultureCode: 'sv-FI',
  urlLanguageFolder: '',
  languageName: 'Finnish',
  countryName: 'Finland',
  countryNameLocale: 'Suomi'
}, {
  marketCode: 'fr',
  domain: 'ef.fr',
  countryCode: 'fr',
  languageCode: 'fr',
  cultureCode: 'fr-FR',
  secondaryCultureCode: 'fr',
  urlLanguageFolder: '',
  languageName: 'French',
  countryName: 'France',
  countryNameLocale: 'France'
}, {
  marketCode: 'gb',
  domain: 'ef.co.uk',
  countryCode: 'gb',
  languageCode: 'en',
  cultureCode: 'en-GB',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'Great Britain',
  countryNameLocale: 'Great Britain'
}, {
  marketCode: 'gr',
  domain: 'ef.com/gr',
  countryCode: 'gr',
  languageCode: 'el',
  cultureCode: 'el',
  secondaryCultureCode: '',
  urlLanguageFolder: '/gr',
  languageName: 'Greek',
  countryName: 'Greece',
  countryNameLocale: 'Ελλάδα'
}, {
  marketCode: 'hk',
  domain: 'ef.com.hk',
  countryCode: 'hk',
  languageCode: 'zh',
  cultureCode: 'zh-Hant-HK',
  secondaryCultureCode: 'zh-MO',
  urlLanguageFolder: '',
  languageName: 'Traditional Chinese',
  countryName: 'Hong Kong',
  countryNameLocale: '香港'
}, {
  marketCode: 'hu',
  domain: 'ef.co.hu',
  countryCode: 'hu',
  languageCode: 'hu',
  cultureCode: 'hu',
  secondaryCultureCode: 'hu-HU',
  urlLanguageFolder: '',
  languageName: 'Hungarian',
  countryName: 'Hungary',
  countryNameLocale: 'Magyarország'
}, {
  marketCode: 'id',
  domain: 'ef.co.id',
  countryCode: 'id',
  languageCode: 'id',
  cultureCode: 'id',
  secondaryCultureCode: 'id-ID',
  urlLanguageFolder: '',
  languageName: 'Bahasa',
  countryName: 'Indonesia',
  countryNameLocale: 'Indonesia'
}, {
  marketCode: 'ie',
  domain: 'ef-ireland.ie',
  countryCode: 'ie',
  languageCode: 'en',
  cultureCode: 'en-IE',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'Ireland',
  countryNameLocale: 'Ireland'
}, {
  marketCode: 'il',
  domain: 'ef.com/il',
  countryCode: 'il',
  languageCode: '',
  cultureCode: 'en-IL',
  secondaryCultureCode: '',
  urlLanguageFolder: '/il',
  languageName: 'English',
  countryName: 'Israel',
  countryNameLocale: 'Israel'
}, {
  marketCode: 'ir',
  domain: 'ef.com/ir',
  countryCode: 'ir',
  languageCode: 'ir',
  cultureCode: 'fa',
  secondaryCultureCode: 'fa-IR',
  urlLanguageFolder: '/ir',
  languageName: 'Persian',
  countryName: 'Iran',
  countryNameLocale: 'ایران'
}, {
  marketCode: 'it',
  domain: 'ef-italia.it',
  countryCode: 'it',
  languageCode: 'it',
  cultureCode: 'it',
  secondaryCultureCode: 'it-IT',
  urlLanguageFolder: '',
  languageName: 'Italian',
  countryName: 'Italy',
  countryNameLocale: 'Italia'
}, {
  marketCode: 'jp',
  domain: 'efjapan.co.jp',
  countryCode: 'jp',
  languageCode: 'ja',
  cultureCode: 'ja',
  secondaryCultureCode: 'ja-JP',
  urlLanguageFolder: '',
  languageName: 'Japanese',
  countryName: 'Japan',
  countryNameLocale: '日本'
}, {
  marketCode: 'kr',
  domain: 'ef.co.kr',
  countryCode: 'kr',
  languageCode: 'ko',
  cultureCode: 'ko',
  secondaryCultureCode: 'ko-KR',
  urlLanguageFolder: '',
  languageName: 'Korean',
  countryName: 'Korea',
  countryNameLocale: '대한민국'
}, {
  marketCode: 'kz',
  domain: 'ef.com/kz',
  countryCode: 'kz',
  languageCode: 'kk',
  cultureCode: 'ru-KZ',
  secondaryCultureCode: 'kk-KZ',
  urlLanguageFolder: '/kz',
  languageName: 'Kazakh',
  countryName: 'Kazakhstan',
  countryNameLocale: 'Қазақстан'
}, {
  marketCode: 'lv',
  domain: 'ef.lv',
  countryCode: 'lv',
  languageCode: 'lv',
  cultureCode: 'lv',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Latvian',
  countryName: 'Latvia',
  countryNameLocale: 'Latvija'
}, {
  marketCode: 'ly',
  domain: 'ef.com.ly',
  countryCode: 'ly',
  languageCode: 'ar',
  cultureCode: 'ar-LY',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Arabic',
  countryName: 'Libya',
  countryNameLocale: 'ليبيا'
}, {
  marketCode: 'mx',
  domain: 'ef.com.mx',
  countryCode: 'mx',
  languageCode: 'es',
  cultureCode: 'es-MX',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Mexico',
  countryNameLocale: 'México'
}, {
  marketCode: 'nl',
  domain: 'ef.nl',
  countryCode: 'nl',
  languageCode: 'nl',
  cultureCode: 'nl',
  secondaryCultureCode: 'nl',
  urlLanguageFolder: '',
  languageName: 'Dutch',
  countryName: 'Netherlands',
  countryNameLocale: 'Nederland'
}, {
  marketCode: 'no',
  domain: 'ef.no',
  countryCode: 'no',
  languageCode: 'no',
  cultureCode: 'no',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Norwegian',
  countryName: 'Norway',
  countryNameLocale: 'Norge'
}, {
  marketCode: 'nz',
  domain: 'ef.co.nz',
  countryCode: 'nz',
  languageCode: 'en',
  cultureCode: 'en-NZ',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'New Zealand',
  countryNameLocale: 'New Zealand'
}, {
  marketCode: 'pa',
  domain: 'ef.com.pa',
  countryCode: 'pa',
  languageCode: 'es',
  cultureCode: 'es-PA',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Panama',
  countryNameLocale: 'Panamá'
}, {
  marketCode: 'pe',
  domain: 'ef.com.pe',
  countryCode: 'pe',
  languageCode: 'es',
  cultureCode: 'es-PE',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Peru',
  countryNameLocale: 'Perú'
}, {
  marketCode: 'pl',
  domain: 'ef.pl',
  countryCode: 'pl',
  languageCode: 'pl',
  cultureCode: 'pl',
  secondaryCultureCode: 'pl-PL',
  urlLanguageFolder: '',
  languageName: 'Polish',
  countryName: 'Poland',
  countryNameLocale: 'Polska'
}, {
  marketCode: 'pt',
  domain: 'ef.edu.pt',
  countryCode: 'pt',
  languageCode: 'pt',
  cultureCode: 'pt-PT',
  secondaryCultureCode: 'pt',
  urlLanguageFolder: '',
  languageName: 'Portuguese',
  countryName: 'Portugal',
  countryNameLocale: 'Portugal'
}, {
  marketCode: 'ro',
  domain: 'ef.ro',
  countryCode: 'ro',
  languageCode: 'ro',
  cultureCode: 'ro',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Romanian',
  countryName: 'Romania',
  countryNameLocale: 'România'
}, {
  marketCode: 'ru',
  domain: 'ef.ru',
  countryCode: 'ru',
  languageCode: 'ru',
  cultureCode: 'ru-RU',
  secondaryCultureCode: 'ru',
  urlLanguageFolder: '',
  languageName: 'Russian',
  countryName: 'Russia',
  countryNameLocale: 'Россия'
}, {
  marketCode: 'sa',
  domain: 'ef.com/sa',
  countryCode: 'sa',
  languageCode: 'sa',
  cultureCode: 'ar-SA',
  secondaryCultureCode: 'en-SA',
  urlLanguageFolder: '/sa',
  languageName: 'Arabic',
  countryName: 'Saudi Arabia',
  countryNameLocale: 'المملكة العربية السعودية'
}, {
  marketCode: 'sx',
  domain: 'ef.com/saen',
  countryCode: 'sx',
  languageCode: 'sa',
  cultureCode: 'en-SA',
  secondaryCultureCode: '',
  urlLanguageFolder: '/saen',
  languageName: 'English',
  countryName: 'Saudi Arabia',
  countryNameLocale: 'Saudi Arabia'
}, {
  marketCode: 'se',
  domain: 'ef.se',
  countryCode: 'se',
  languageCode: 'sv',
  cultureCode: 'sv',
  secondaryCultureCode: 'sv-SE',
  urlLanguageFolder: '',
  languageName: 'Swedish',
  countryName: 'Sweden',
  countryNameLocale: 'Sverige'
}, {
  marketCode: 'sg',
  domain: 'ef.sg',
  countryCode: 'sg',
  languageCode: 'en',
  cultureCode: 'en-SG',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'Singapore',
  countryNameLocale: 'Singapore'
}, {
  marketCode: 'si',
  domain: 'ef.si',
  countryCode: 'si',
  languageCode: 'si',
  cultureCode: 'sl',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Slovenian',
  countryName: 'Slovenia',
  countryNameLocale: 'Slovenija'
}, {
  marketCode: 'sk',
  domain: 'ef-slovakia.sk',
  countryCode: 'sk',
  languageCode: 'sk',
  cultureCode: 'sk',
  secondaryCultureCode: 'sk-SK',
  urlLanguageFolder: '',
  languageName: 'Slovakian',
  countryName: 'Slovakia',
  countryNameLocale: 'Slovensko'
}, {
  marketCode: 'th',
  domain: 'ef.co.th',
  countryCode: 'th',
  languageCode: 'th',
  cultureCode: 'th',
  secondaryCultureCode: 'th-TH',
  urlLanguageFolder: '',
  languageName: 'Thai',
  countryName: 'Thailand',
  countryNameLocale: 'ประเทศไทย'
}, {
  marketCode: 'tn',
  domain: 'ef.tn/fr',
  countryCode: 'tn',
  languageCode: 'fr',
  cultureCode: 'fr-TN',
  secondaryCultureCode: '',
  urlLanguageFolder: '/fr',
  languageName: 'French',
  countryName: 'Tunisia',
  countryNameLocale: 'Tunisie'
}, {
  marketCode: 'tx',
  domain: 'ef.tn/ar',
  countryCode: 'tx',
  languageCode: 'ar',
  cultureCode: 'ar-TN',
  secondaryCultureCode: '',
  urlLanguageFolder: '/ar',
  languageName: 'Arabic',
  countryName: 'Tunisia',
  countryNameLocale: 'تونس'
}, {
  marketCode: 'tr',
  domain: 'ef.com.tr',
  countryCode: 'tr',
  languageCode: 'tr',
  cultureCode: 'tr',
  secondaryCultureCode: 'tr-TR',
  urlLanguageFolder: '',
  languageName: 'Turkish',
  countryName: 'Turkey',
  countryNameLocale: 'Türkiye'
}, {
  marketCode: 'tw',
  domain: 'ef.com.tw',
  countryCode: 'tw',
  languageCode: 'zh',
  cultureCode: 'zh-Hant',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Traditional Chinese',
  countryName: 'Taiwan',
  countryNameLocale: '台灣'
}, {
  marketCode: 'uk',
  domain: 'ef.co.uk',
  countryCode: 'uk',
  languageCode: 'en',
  cultureCode: 'en-GB',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'United Kingdom',
  countryNameLocale: 'United Kingdom'
}, {
  marketCode: 'us',
  domain: 'ef.edu',
  countryCode: 'us',
  languageCode: 'en',
  cultureCode: 'en-US',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'English',
  countryName: 'United States',
  countryNameLocale: 'United States'
}, {
  marketCode: 'uy',
  domain: 'ef.com.uy',
  countryCode: 'uy',
  languageCode: 'es',
  cultureCode: 'es-UY',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Uruguay',
  countryNameLocale: 'Uruguay'
}, {
  marketCode: 've',
  domain: 'ef.co.ve',
  countryCode: 've',
  languageCode: 'es',
  cultureCode: 'es-VE',
  secondaryCultureCode: '',
  urlLanguageFolder: '',
  languageName: 'Spanish',
  countryName: 'Venezuela',
  countryNameLocale: 'Venezuela'
}, {
  marketCode: 'vn',
  domain: 'ef.com.vn',
  countryCode: 'vn',
  languageCode: 'vi',
  cultureCode: 'vi',
  secondaryCultureCode: 'vi-VN',
  urlLanguageFolder: '',
  languageName: 'Vietnamese',
  countryName: 'Vietnam',
  countryNameLocale: 'Việt Nam'
}, {
  marketCode: 'wc',
  domain: 'ef.com/wwfr',
  countryCode: 'wc',
  languageCode: 'wwfr',
  cultureCode: 'fr',
  secondaryCultureCode: 'fa',
  urlLanguageFolder: '/wwfr',
  languageName: 'French',
  countryName: 'World Wide',
  countryNameLocale: 'Global Site - Français'
}, {
  marketCode: 'we',
  domain: 'ef.com/wwen',
  countryCode: 'we',
  languageCode: 'en',
  cultureCode: 'en',
  secondaryCultureCode: 'en-GB',
  urlLanguageFolder: '/wwen',
  languageName: 'English',
  countryName: 'World Wide',
  countryNameLocale: 'Global Site - English'
}, {
  marketCode: 'wl',
  domain: 'ef.com/wwes',
  countryCode: 'wl',
  languageCode: 'wwes',
  cultureCode: 'es',
  secondaryCultureCode: 'fa',
  urlLanguageFolder: '/wwes',
  languageName: 'Spanish',
  countryName: 'World Wide',
  countryNameLocale: 'Global Site - Español'
}, {
  marketCode: 'wm',
  domain: 'ef.com/wwar',
  countryCode: 'wm',
  languageCode: 'wwar',
  cultureCode: 'ar',
  secondaryCultureCode: 'fa',
  urlLanguageFolder: '/wwar',
  languageName: 'Arabic',
  countryName: 'World Wide',
  countryNameLocale: 'Global Site - العربية'
}, {
  marketCode: 'wp',
  domain: 'ef.com/wwpt',
  countryCode: 'wp',
  languageCode: 'wwpt',
  cultureCode: 'pt',
  secondaryCultureCode: '',
  urlLanguageFolder: '/wwpt',
  languageName: 'Portuguese',
  countryName: 'World Wide',
  countryNameLocale: 'Global site - Português'
}, {
  marketCode: 'wr',
  domain: 'ef.com/wwru',
  countryCode: 'wr',
  languageCode: 'wwru',
  cultureCode: 'ru',
  secondaryCultureCode: 'fa',
  urlLanguageFolder: '/wwru',
  languageName: 'Russian',
  countryName: 'World Wide',
  countryNameLocale: 'Global site - Русский'
}];
exports.default = markets;